export default "__VITE_ASSET__DNDlkoj4__"